import React from 'react';
import './Footer.scss';

const Footer = () => {
  return <div className="footer text-center" />;
};

export default Footer;
